import angular from 'angular'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'

angular.module('pub.channel.edition', []).controller('ChannelEditionCtrl', ChannelEditionCtrl)

/** @ngInject */
function ChannelEditionCtrl(
  $scope,
  $rootScope,
  $q,
  $stateParams,
  $timeout,
  $location,
  $state,
  $sce,
  UploadService,
  TranslatorService,
  ChannelsService,
  CacheService,
  SetsService,
  TagsService,
  TranslationChannelService,
  CsvService,
  PublisherAdminService,
) {
  var vm = this
  vm.model = {}
  vm.model2 = {}

  const toolbarOptions = {
    container: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ list: 'ordered' }, { list: 'bullet' }],

      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['clean'], // remove formatting button

      ['link'], // link and image, video
      [{ align: [] }], // text alignment
    ],
  }

  const options = {
    modules: {
      toolbar: toolbarOptions,
    },
    placeholder: 'Write something...',
    theme: 'snow',
  }
  const editor = new Quill('.editor', options)
  vm.loadF = false
  vm.loadT = false
  vm.loadH = false
  vm.loadHWeb = false
  vm.loadHMob = false
  vm.loadL = false
  vm.loadS = false
  vm.loadW = false
  vm.loadLSM = false
  vm.loadDSM = false
  vm.loadLLG = false
  vm.loadDLG = false
  vm.loadT11 = false
  vm.loadT12 = false
  vm.loadT13 = false
  vm.loadT22 = false
  vm.loadLand = false
  vm.loadAd = false
  vm.loadVideo = false
  vm.loadAdWeb = false
  vm.loadPhS = false
  vm.loadPhCf = false
  vm.loadPhT = false
  vm.loadPhCb = false
  vm.loadPhObj = false
  vm.pathImgF = ''
  vm.pathImgT = ''
  vm.pathImgH = ''
  vm.pathImgHWeb = ''
  vm.pathImgHMob = ''
  vm.pathImgL = ''
  vm.pathImgS = ''
  vm.pathImgW = ''
  vm.pathImgLSM = ''
  vm.pathImgDSM = ''
  vm.pathImgLLG = ''
  vm.pathImgDLG = ''
  vm.pathImgT11 = ''
  vm.pathImgT21 = ''
  vm.pathImgT31 = ''
  vm.pathImgT22 = ''
  vm.pathScreen = ''
  vm.pathImgLand = ''
  vm.pathImgAd = ''
  // vm.pathVideoTrailer = ''
  vm.pathImgAdWeb = ''
  vm.pathImgPhT = ''
  vm.pathImgPhS = ''
  vm.pathImgPhCf = ''
  vm.pathImgPhCb = ''
  vm.pathPhObj = ''
  vm.isUpload = true
  vm.tags = []
  vm.rows = []
  $('.button-dark').removeClass('is-active')
  $('.button-light').addClass('is-active')
  var edit = $location.$$path.indexOf('edit') !== -1
  $('html, body').animate({ scrollTop: 0 }, 1000)
  vm.tagsList = []
  vm.roys = []
  vm.listAge = [
    {
      id: 0,
      text: 'Channel Rating',
    },
    {
      id: 13,
      text: '13+',
    },
    {
      id: 18,
      text: '18+',
    },
  ]
  vm.checklistOptions = [
    {
      id: 'clean_slate',
      name: 'Recollect',
    },
    {
      id: 'rank',
      name: 'Rank',
    },
  ]
  vm.albumTypes = [
    {
      id: 'channel',
      name: 'Channel',
    },
    {
      id: 'sets',
      name: 'Set',
    },
    {
      id: 'awards',
      name: 'Award',
    },
  ]

  vm.isOpen = false
  vm.isOpen2 = false
  vm.isOpen3 = false
  vm.sets = []
  vm.model.tags = []

  $rootScope.$on('tagsList', function (event, data) {
    if (vm.tagsList) {
      data.map(function (item) {
        vm.tagsList.push(item)
      })
      vm.tagsList = _.uniqBy(vm.tagsList, 'id')
    } else {
      vm.tagsList = data
    }
  })

  vm.restrictions = []
  vm.locales = [
    { value: 'AF', label: 'Afghanistan' },
    { value: 'AX', label: 'Åland Islands' },
    { value: 'AL', label: 'Albania' },
    { value: 'DZ', label: 'Algeria' },
    { value: 'AS', label: 'American Samoa' },
    { value: 'AD', label: 'Andorra' },
    { value: 'AO', label: 'Angola' },
    { value: 'AI', label: 'Anguilla' },
    { value: 'AQ', label: 'Antarctica' },
    { value: 'AG', label: 'Antigua and Barbuda' },
    { value: 'AR', label: 'Argentina' },
    { value: 'AM', label: 'Armenia' },
    { value: 'AW', label: 'Aruba' },
    { value: 'AU', label: 'Australia' },
    { value: 'AT', label: 'Austria' },
    { value: 'AZ', label: 'Azerbaijan' },
    { value: 'BS', label: 'Bahamas' },
    { value: 'BH', label: 'Bahrain' },
    { value: 'BD', label: 'Bangladesh' },
    { value: 'BB', label: 'Barbados' },
    { value: 'BY', label: 'Belarus' },
    { value: 'BE', label: 'Belgium' },
    { value: 'BZ', label: 'Belize' },
    { value: 'BJ', label: 'Benin' },
    { value: 'BM', label: 'Bermuda' },
    { value: 'BT', label: 'Bhutan' },
    { value: 'BO', label: 'Bolivia' },
    { value: 'BA', label: 'Bosnia and Herzegovina' },
    { value: 'BW', label: 'Botswana' },
    { value: 'BV', label: 'Bouvet Island' },
    { value: 'BR', label: 'Brazil' },
    { value: 'IO', label: 'British Indian Ocean Territory' },
    { value: 'BN', label: 'Brunei Darussalam' },
    { value: 'BG', label: 'Bulgaria' },
    { value: 'BF', label: 'Burkina Faso' },
    { value: 'BI', label: 'Burundi' },
    { value: 'KH', label: 'Cambodia' },
    { value: 'CM', label: 'Cameroon' },
    { value: 'CA', label: 'Canada' },
    { value: 'CV', label: 'Cape Verde' },
    { value: 'KY', label: 'Cayman Islands' },
    { value: 'CF', label: 'Central African Republic' },
    { value: 'TD', label: 'Chad' },
    { value: 'CL', label: 'Chile' },
    { value: 'CN', label: 'China' },
    { value: 'CX', label: 'Christmas Island' },
    { value: 'CC', label: 'Cocos (Keeling) Islands' },
    { value: 'CO', label: 'Colombia' },
    { value: 'KM', label: 'Comoros' },
    { value: 'CG', label: 'Congo' },
    { value: 'CD', label: 'Congo, The Democratic Republic of the' },
    { value: 'CK', label: 'Cook Islands' },
    { value: 'CR', label: 'Costa Rica' },
    { value: 'CI', label: "Cote D'Ivoire" },
    { value: 'HR', label: 'Croatia' },
    { value: 'CU', label: 'Cuba' },
    { value: 'CY', label: 'Cyprus' },
    { value: 'CZ', label: 'Czech Republic' },
    { value: 'DK', label: 'Denmark' },
    { value: 'DJ', label: 'Djibouti' },
    { value: 'DM', label: 'Dominica' },
    { value: 'DO', label: 'Dominican Republic' },
    { value: 'EC', label: 'Ecuador' },
    { value: 'EG', label: 'Egypt' },
    { value: 'SV', label: 'El Salvador' },
    { value: 'GQ', label: 'Equatorial Guinea' },
    { value: 'ER', label: 'Eritrea' },
    { value: 'EE', label: 'Estonia' },
    { value: 'ET', label: 'Ethiopia' },
    { value: 'FK', label: 'Falkland Islands (Malvinas)' },
    { value: 'FO', label: 'Faroe Islands' },
    { value: 'FJ', label: 'Fiji' },
    { value: 'FI', label: 'Finland' },
    { value: 'FR', label: 'France' },
    { value: 'GF', label: 'French Guiana' },
    { value: 'PF', label: 'French Polynesia' },
    { value: 'TF', label: 'French Southern Territories' },
    { value: 'GA', label: 'Gabon' },
    { value: 'GM', label: 'Gambia' },
    { value: 'GE', label: 'Georgia' },
    { value: 'DE', label: 'Germany' },
    { value: 'GH', label: 'Ghana' },
    { value: 'GI', label: 'Gibraltar' },
    { value: 'GR', label: 'Greece' },
    { value: 'GL', label: 'Greenland' },
    { value: 'GD', label: 'Grenada' },
    { value: 'GP', label: 'Guadeloupe' },
    { value: 'GU', label: 'Guam' },
    { value: 'GT', label: 'Guatemala' },
    { value: 'GG', label: 'Guernsey' },
    { value: 'GN', label: 'Guinea' },
    { value: 'GW', label: 'Guinea-Bissau' },
    { value: 'GY', label: 'Guyana' },
    { value: 'HT', label: 'Haiti' },
    { value: 'HM', label: 'Heard Island and Mcdonald Islands' },
    { value: 'VA', label: 'Holy See (Vatican City State)' },
    { value: 'HN', label: 'Honduras' },
    { value: 'HK', label: 'Hong Kong' },
    { value: 'HU', label: 'Hungary' },
    { value: 'IS', label: 'Iceland' },
    { value: 'IN', label: 'India' },
    { value: 'ID', label: 'Indonesia' },
    { value: 'IR', label: 'Iran, Islamic Republic Of' },
    { value: 'IQ', label: 'Iraq' },
    { value: 'IE', label: 'Ireland' },
    { value: 'IM', label: 'Isle of Man' },
    { value: 'IL', label: 'Israel' },
    { value: 'IT', label: 'Italy' },
    { value: 'JM', label: 'Jamaica' },
    { value: 'JP', label: 'Japan' },
    { value: 'JE', label: 'Jersey' },
    { value: 'JO', label: 'Jordan' },
    { value: 'KZ', label: 'Kazakhstan' },
    { value: 'KE', label: 'Kenya' },
    { value: 'KI', label: 'Kiribati' },
    { value: 'KP', label: "Korea, Democratic People's Republic of" },
    { value: 'KR', label: 'Korea, Republic of' },
    { value: 'KW', label: 'Kuwait' },
    { value: 'KG', label: 'Kyrgyzstan' },
    { value: 'LA', label: "Lao People's Democratic Republic" },
    { value: 'LV', label: 'Latvia' },
    { value: 'LB', label: 'Lebanon' },
    { value: 'LS', label: 'Lesotho' },
    { value: 'LR', label: 'Liberia' },
    { value: 'LY', label: 'Libyan Arab Jamahiriya' },
    { value: 'LI', label: 'Liechtenstein' },
    { value: 'LT', label: 'Lithuania' },
    { value: 'LU', label: 'Luxembourg' },
    { value: 'MO', label: 'Macao' },
    { value: 'MK', label: 'Macedonia, The Former Yugoslav Republic of' },
    { value: 'MG', label: 'Madagascar' },
    { value: 'MW', label: 'Malawi' },
    { value: 'MY', label: 'Malaysia' },
    { value: 'MV', label: 'Maldives' },
    { value: 'ML', label: 'Mali' },
    { value: 'MT', label: 'Malta' },
    { value: 'MH', label: 'Marshall Islands' },
    { value: 'MQ', label: 'Martinique' },
    { value: 'MR', label: 'Mauritania' },
    { value: 'MU', label: 'Mauritius' },
    { value: 'YT', label: 'Mayotte' },
    { value: 'MX', label: 'Mexico' },
    { value: 'FM', label: 'Micronesia, Federated States of' },
    { value: 'MD', label: 'Moldova, Republic of' },
    { value: 'MC', label: 'Monaco' },
    { value: 'MN', label: 'Mongolia' },
    { value: 'MS', label: 'Montserrat' },
    { value: 'MA', label: 'Morocco' },
    { value: 'MZ', label: 'Mozambique' },
    { value: 'MM', label: 'Myanmar' },
    { value: 'NA', label: 'Namibia' },
    { value: 'NR', label: 'Nauru' },
    { value: 'NP', label: 'Nepal' },
    { value: 'NL', label: 'Netherlands' },
    { value: 'AN', label: 'Netherlands Antilles' },
    { value: 'NC', label: 'New Caledonia' },
    { value: 'NZ', label: 'New Zealand' },
    { value: 'NI', label: 'Nicaragua' },
    { value: 'NE', label: 'Niger' },
    { value: 'NG', label: 'Nigeria' },
    { value: 'NU', label: 'Niue' },
    { value: 'NF', label: 'Norfolk Island' },
    { value: 'MP', label: 'Northern Mariana Islands' },
    { value: 'NO', label: 'Norway' },
    { value: 'OM', label: 'Oman' },
    { value: 'PK', label: 'Pakistan' },
    { value: 'PW', label: 'Palau' },
    { value: 'PS', label: 'Palestinian Territory, Occupied' },
    { value: 'PA', label: 'Panama' },
    { value: 'PG', label: 'Papua New Guinea' },
    { value: 'PY', label: 'Paraguay' },
    { value: 'PE', label: 'Peru' },
    { value: 'PH', label: 'Philippines' },
    { value: 'PN', label: 'Pitcairn' },
    { value: 'PL', label: 'Poland' },
    { value: 'PT', label: 'Portugal' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'QA', label: 'Qatar' },
    { value: 'RE', label: 'Reunion' },
    { value: 'RO', label: 'Romania' },
    { value: 'RU', label: 'Russian Federation' },
    { value: 'RW', label: 'Rwanda' },
    { value: 'BL', label: 'Saint-Barthélemy' },
    { value: 'SH', label: 'Saint Helena' },
    { value: 'KN', label: 'Saint Kitts and Nevis' },
    { value: 'LC', label: 'Saint Lucia' },
    { value: 'MF', label: 'Saint-Martin' },
    { value: 'PM', label: 'Saint Pierre and Miquelon' },
    { value: 'VC', label: 'Saint Vincent and the Grenadines' },
    { value: 'WS', label: 'Samoa' },
    { value: 'SM', label: 'San Marino' },
    { value: 'ST', label: 'Sao Tome and Principe' },
    { value: 'SA', label: 'Saudi Arabia' },
    { value: 'SN', label: 'Senegal' },
    { value: 'RS', label: 'Serbia' },
    { value: 'CS', label: 'Serbia and Montenegro' },
    { value: 'SC', label: 'Seychelles' },
    { value: 'SL', label: 'Sierra Leone' },
    { value: 'SG', label: 'Singapore' },
    { value: 'SK', label: 'Slovakia' },
    { value: 'SI', label: 'Slovenia' },
    { value: 'SB', label: 'Solomon Islands' },
    { value: 'SO', label: 'Somalia' },
    { value: 'ZA', label: 'South Africa' },
    { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
    { value: 'SS', label: 'South Sudan' },
    { value: 'ES', label: 'Spain' },
    { value: 'LK', label: 'Sri Lanka' },
    { value: 'SD', label: 'Sudan' },
    { value: 'SR', label: 'Surilabel' },
    { value: 'SJ', label: 'Svalbard and Jan Mayen' },
    { value: 'SZ', label: 'Swaziland' },
    { value: 'SE', label: 'Sweden' },
    { value: 'CH', label: 'Switzerland' },
    { value: 'SY', label: 'Syrian Arab Republic' },
    { value: 'TW', label: 'Taiwan' },
    { value: 'TJ', label: 'Tajikistan' },
    { value: 'TZ', label: 'Tanzania, United Republic of' },
    { value: 'TH', label: 'Thailand' },
    { value: 'TL', label: 'Timor-Leste' },
    { value: 'TG', label: 'Togo' },
    { value: 'TK', label: 'Tokelau' },
    { value: 'TO', label: 'Tonga' },
    { value: 'TT', label: 'Trinidad and Tobago' },
    { value: 'TN', label: 'Tunisia' },
    { value: 'TR', label: 'Turkey' },
    { value: 'TM', label: 'Turkmenistan' },
    { value: 'TC', label: 'Turks and Caicos Islands' },
    { value: 'TV', label: 'Tuvalu' },
    { value: 'UG', label: 'Uganda' },
    { value: 'UA', label: 'Ukraine' },
    { value: 'AE', label: 'United Arab Emirates' },
    { value: 'GB', label: 'United Kingdom' },
    { value: 'US', label: 'United States' },
    { value: 'UM', label: 'United States Minor Outlying Islands' },
    { value: 'UY', label: 'Uruguay' },
    { value: 'UZ', label: 'Uzbekistan' },
    { value: 'VU', label: 'Vanuatu' },
    { value: 'VE', label: 'Venezuela' },
    { value: 'VN', label: 'Vietnam' },
    { value: 'VG', label: 'Virgin Islands, British' },
    { value: 'VI', label: 'Virgin Islands, U.S.' },
    { value: 'WF', label: 'Wallis and Futuna' },
    { value: 'EH', label: 'Western Sahara' },
    { value: 'YE', label: 'Yemen' },
    { value: 'ZM', label: 'Zambia' },
    { value: 'ZW', label: 'Zimbabwe' },
  ]

  vm.removeAll = function () {
    vm.restrictions = []
  }

  vm.banners = []
  vm.channelTranslations = []
  function loadTranslations() {
    TranslationChannelService.listTranslations($stateParams.id).then(function (result) {
      vm.channelTranslations = result.results
    })
  }

  function loadSets() {
    SetsService.getChannelId($stateParams.id).then(function (result) {
      vm.sets = result.results
    })
  }

  PublisherAdminService.getPublisher().then(function (result) {
    vm.publishers = result.results
  })

  vm.genres = []
  ChannelsService.listGenres().then(function (result) {
    vm.genres = result.results
  })

  loadTranslations()
  loadSets()

  vm.title = null

  vm.validateYoutubeURL = function (url) {
    if (!url) return ''

    // Only allow direct video links (with v= or youtu.be)
    // Block Shorts and Playlist explicitly
    var shortsRegex = /youtube\.com\/shorts\//i
    var playlistRegex = /[?&]list=/i
    var validVideoRegex =
      /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]{11}(\S+)?$/

    if (shortsRegex.test(url)) {
      return 'Shorts not supported'
    } else if (playlistRegex.test(url)) {
      return 'Playlist not supported'
    } else if (!validVideoRegex.test(url)) {
      return 'Invalid URL'
    } else {
      return ''
    }
  }

  vm.validateSpotifyURL = function (url) {
    if (!url) return ''

    // Only allow Spotify album or track links
    // Format: https://open.spotify.com/album/[ID] or https://open.spotify.com/track/[ID] or https://open.spotify.com/playlist/[ID]
    // They can have query params or extra paths
    var validRegex =
      /^https:\/\/open\.spotify\.com\/(album|track|playlist)\/[a-zA-Z0-9]+(\/.*|\?.*|$)/i

    if (!validRegex.test(url)) {
      return 'Invalid Spotify URL. Only album, playlist or track url are supported.'
    }
    return ''
  }

  if (edit) {
    vm.breadcrumb = 'product/channels/edit'
    ChannelsService.getId($stateParams.id).then(function (result) {
      vm.model = result.results
      vm.title = vm.model.t
      vm.description = vm.model.txt
      editor.clipboard.dangerouslyPasteHTML(vm.model.txt || '')
      vm.model.trans = vm.model.trans
      vm.pathImgT = vm.model['img-t']
      vm.pathImgH = vm.model['img-h']
      vm.pathImgHWeb = vm.model['img-h-web']
      vm.pathImgHMob = vm.model['img-h-mob']
      vm.pathImgL = vm.model['img-s-s']
      vm.pathImgS = vm.model['img-s']
      vm.pathImgW = vm.model['img-wel']
      vm.pathImgLSM = vm.model['img-logo-l-sm']
      vm.pathImgDSM = vm.model['img-logo-d-sm']
      vm.pathImgLLG = vm.model['img-logo-l-lg']
      vm.pathImgDLG = vm.model['img-logo-d-lg']
      vm.pathImgLand = vm.model['img-web-l'] === undefined ? '' : vm.model['img-web-l']
      vm.pathImgT11 = vm.model['img-11'] === undefined ? '' : vm.model['img-11']
      vm.pathImgT21 = vm.model['img-21'] === undefined ? '' : vm.model['img-21']
      vm.pathImgT31 = vm.model['img-31'] === undefined ? '' : vm.model['img-31']
      vm.pathImgT22 = vm.model['img-22'] === undefined ? '' : vm.model['img-22']
      vm.pathImgAd = vm.model['img-ad'] === undefined ? '' : vm.model['img-ad']
      // vm.pathVideoTrailer = vm.model['vid-t'] === undefined ? '' : vm.model['vid-t']
      // if (vm.pathVideoTrailer)
      //   vm.videoTrailer = $sce.trustAsResourceUrl(
      //     $rootScope.urlS3 + '/channels/' + vm.pathVideoTrailer,
      //   )
      vm.pathImgAdWeb = vm.model['img-ad-web'] === undefined ? '' : vm.model['img-ad-web']
      vm.pathImgPhT = vm.model['img-ph-t'] === undefined ? '' : vm.model['img-ph-t']
      vm.pathImgPhS = vm.model['img-ph-s'] === undefined ? '' : vm.model['img-ph-s']
      vm.pathImgPhCf = vm.model['img-ph-cf'] === undefined ? '' : vm.model['img-ph-cf']
      vm.pathImgPhCb = vm.model['img-ph-cb'] === undefined ? '' : vm.model['img-ph-cb']
      vm.pathPhObj = vm.model['obj-ph'] === undefined ? '' : vm.model['obj-ph']

      vm.glossaryName = vm.model['id-gl'] || ''
      vm.isUpload = false

      if (!vm.model['color-hl']) {
        vm.model['color-hl'] = '#ffffff'
      }
      if (!vm.model['color-txt']) {
        vm.model['color-txt'] = '#ffffff'
      }
      if (!vm.model['color-bg']) {
        vm.model['color-bg'] = '#000000'
      }

      // Prepend Spotify domain if backend only stored the path (e.g. "album/xxx" or "track/xxx")
      if (vm.model['ctr-url'] && !vm.model['ctr-url'].startsWith('http')) {
        vm.model['ctr-url'] = 'https://open.spotify.com/' + vm.model['ctr-url']
      }

      if (vm.model.rl !== undefined || vm.model.rl !== '_') {
        vm.restrictions = vm.model.rl.split(',')
      }

      if (vm.model.tags) {
        for (var i = 0; i < vm.model.tags.length; i++) {
          vm.tags.push(vm.model.tags[i].id)
        }
      } else {
        vm.model.tags = []
      }

      if (vm.model['yt-links']) {
        vm.ytLinks = vm.model['yt-links'].map(function (item) {
          return {
            id: item.id,
            'vid-id': `https://youtu.be/${item['vid-id']}`,
            desc: item.desc,
          }
        })
      }

      if (vm.model.roy !== undefined) {
        for (var i = 0; i < vm.model.roy.length; i++) {
          var item = {
            pubId: vm.model.roy[i]['id-pu'],
            royId: vm.model.roy[i].id,
            roys: [vm.model.roy[i]],
          }
          vm.roys.push(item)

          vm.changePub(item)
        }
      }

      if (vm.model['ts-p'] !== undefined && vm.model['ts-p'] !== 0) {
        vm.model['ts-p'] = vm.model['ts-p'] / 1000
        vm.model['ts-p'] = new Date(parseInt(vm.model['ts-p']))
        // set seconds to zero
        vm.model['ts-p'].setSeconds(0)
        vm.date = angular.copy(vm.model['ts-p'])
      }

      $('#e7').select2('data', vm.model.tags)

      ChannelsService.listFeatureBanners().then(function (result1) {
        ChannelsService.listRowTypes().then(function (result2) {
          var rows = _.filter(result2.results, function (o) {
            return o.url.indexOf('banner_lists') !== -1
          })
          for (var i = 0; i < rows.length; i++) {
            rows[i].id = parseInt(rows[i].url.split('banner_lists/')[1].split('/banners')[0])
          }

          var banners = result1.results.concat(rows)
          vm.banners = _.uniqBy(banners, 'id')
        })
      })
    })
    ChannelsService.listChannelFeatureBanners($stateParams.id).then(function (result) {
      if (result) {
        vm.model['id-bl'] = result.results.id
      }
    })
  } else {
    vm.breadcrumb = 'product/channels/create'
    ChannelsService.listFeatureBanners().then(function (result1) {
      ChannelsService.listRowTypes().then(function (result2) {
        vm.rows = _.filter(result2.results, function (o) {
          return o.url.indexOf('banner_lists') !== -1
        })
        vm.banners = result1.results.concat(vm.rows)
      })
    })
  }

  vm.viewSweepPdf = function () {
    if (!vm.model['st-pdf']) return
    const url = $rootScope.urlS3 + '/channels/' + vm.model['st-pdf']
    window.open(url, '_blank')
  }

  vm.deleteSweepPdf = function () {
    vm.model['st-pdf'] = ''
    vm.loadSweepPdf = false
  }

  // var makeTranslation = function (t, txt, sht, txt_wel, currentTranslations, paramsId, route) {
  //   if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //     if (vm.title === t && vm.description === txt) {
  //       if (route === 'intro') {
  //         CacheService.saveId('channelId', paramsId)
  //         $state.go(route)
  //         return
  //       } else {
  //         $state.go(route, { parentId: paramsId })
  //         return
  //       }
  //     }
  //   }

  //   TranslatorService.translateChannelAllLanguage(t, txt, sht, txt_wel, vm.glossaryName).then(
  //     function (res) {
  //       var languages = ['ja', 'ko', 'zh', 'zh-TW']

  //       for (var i = 0; i < currentTranslations.length; i++) {
  //         for (var key in res.t.results) {
  //           if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
  //             languages.remove('ja')
  //           }
  //           if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
  //             languages.remove('ko')
  //           }
  //           if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
  //             languages.remove('zh')
  //           }
  //           if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
  //             languages.remove('zh-TW')
  //           }
  //         }
  //       }

  //       if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //         var promises = []

  //         for (var i = 0; i < currentTranslations.length; i++) {
  //           // if (currentTranslations[i]['id-u']) {
  //           //   continue
  //           // }
  //           if (currentTranslations[i].comm === 'SC' && res.t.results) {
  //             var exist = _.find(languages, 'zh')
  //             if (exist) {
  //               promises.push(
  //                 TranslationChannelService.createTranslation(paramsId, {
  //                   'id-u': 0,
  //                   comm: 'SC',
  //                   t: res.t.results.zh,
  //                   txt: res.txt ? res.txt.results.zh : '',
  //                   sht: res.sht ? res.sht.results.zh : '',
  //                   'txt-wel': res.txt_wel ? res.txt_wel.results.zh : '',
  //                 }),
  //               )
  //             } else {
  //               promises.push(
  //                 TranslationChannelService.updateTranslation(currentTranslations[i].id, {
  //                   'id-u': 0,
  //                   t: res.t.results.zh,
  //                   txt: res.txt ? res.txt.results.zh : '',
  //                   sht: res.sht ? res.sht.results.zh : '',
  //                   'txt-wel': res.txt_wel ? res.txt_wel.results.zh : '',
  //                 }),
  //               )
  //             }
  //             continue
  //           }
  //           if (currentTranslations[i].comm === 'TC' && res.t.results) {
  //             var exist = _.find(languages, 'zh-TW')
  //             if (exist) {
  //               promises.push(
  //                 TranslationChannelService.createTranslation(paramsId, {
  //                   'id-u': 0,
  //                   comm: 'TC',
  //                   t: res.t.results['zh-TW'],
  //                   txt: res.txt ? res.txt.results['zh-TW'] : '',
  //                   sht: res.sht ? res.sht.results['zh-TW'] : '',
  //                   'txt-wel': res.txt_wel ? res.txt_wel.results['zh-TW'] : '',
  //                 }),
  //               )
  //             } else {
  //               promises.push(
  //                 TranslationChannelService.updateTranslation(currentTranslations[i].id, {
  //                   'id-u': 0,
  //                   t: res.t.results['zh-TW'],
  //                   txt: res.txt ? res.txt.results['zh-TW'] : '',
  //                   sht: res.sht ? res.sht.results['zh-TW'] : '',
  //                   'txt-wel': res.txt_wel ? res.txt_wel.results['zh-TW'] : '',
  //                 }),
  //               )
  //             }
  //             continue
  //           }
  //           if (currentTranslations[i].comm === 'KR' && res.t.results) {
  //             var exist = _.find(languages, 'ko')
  //             if (exist) {
  //               promises.push(
  //                 TranslationChannelService.createTranslation(paramsId, {
  //                   'id-u': 0,
  //                   comm: 'KR',
  //                   t: res.t.results.ko,
  //                   txt: res.txt ? res.txt.results.ko : '',
  //                   sht: res.sht ? res.sht.results.ko : '',
  //                   'txt-wel': res.txt_wel ? res.txt_wel.results.ko : '',
  //                 }),
  //               )
  //             } else {
  //               promises.push(
  //                 TranslationChannelService.updateTranslation(currentTranslations[i].id, {
  //                   'id-u': 0,
  //                   t: res.t.results.ko,
  //                   txt: res.txt ? res.txt.results.ko : '',
  //                   sht: res.sht ? res.sht.results.ko : '',
  //                   'txt-wel': res.txt_wel ? res.txt_wel.results.ko : '',
  //                 }),
  //               )
  //             }
  //             continue
  //           }
  //           if (currentTranslations[i].comm === 'JP' && res.t.results) {
  //             var exist = _.find(languages, 'ja')
  //             if (exist) {
  //               promises.push(
  //                 TranslationChannelService.createTranslation(paramsId, {
  //                   'id-u': 0,
  //                   comm: 'JP',
  //                   t: res.t.results.ja,
  //                   txt: res.txt ? res.txt.results.ja : '',
  //                   sht: res.sht ? res.sht.results.ja : '',
  //                   'txt-wel': res.txt_wel ? res.txt_wel.results.ja : '',
  //                 }),
  //               )
  //             } else {
  //               promises.push(
  //                 TranslationChannelService.updateTranslation(currentTranslations[i].id, {
  //                   'id-u': 0,
  //                   t: res.t.results.ja,
  //                   txt: res.txt ? res.txt.results.ja : '',
  //                   sht: res.sht ? res.sht.results.ja : '',
  //                   'txt-wel': res.txt_wel ? res.txt_wel.results.ja : '',
  //                 }),
  //               )
  //             }
  //             continue
  //           }
  //         }

  //         $q.all(promises)
  //           .then(function () {
  //             if (route === 'intro') {
  //               CacheService.saveId('channelId', paramsId)
  //               $state.go(route)
  //             } else {
  //               $state.go(route, { parentId: paramsId })
  //             }
  //           })
  //           .catch(function (err) {
  //             swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //           })
  //       }

  //       var promises = []

  //       for (var i = 0; i < languages.length; i++) {
  //         if (languages[i] === 'zh' && res.t.results) {
  //           promises.push(
  //             TranslationChannelService.createTranslation(paramsId, {
  //               'id-u': 0,
  //               comm: 'SC',
  //               t: res.t.results.zh,
  //               txt: res.txt ? res.txt.results.zh : '',
  //               sht: res.sht ? res.sht.results.zh : '',
  //               'txt-wel': res.txt_wel ? res.txt_wel.results.zh : '',
  //             }),
  //           )
  //         }
  //         if (languages[i] === 'zh-TW' && res.t.results) {
  //           promises.push(
  //             TranslationChannelService.createTranslation(paramsId, {
  //               'id-u': 0,
  //               comm: 'TC',
  //               t: res.t.results['zh-TW'],
  //               txt: res.txt ? res.txt.results['zh-TW'] : '',
  //               sht: res.sht ? res.sht.results['zh-TW'] : '',
  //               'txt-wel': res.txt_wel ? res.txt_wel.results['zh-TW'] : '',
  //             }),
  //           )
  //         }
  //         if (languages[i] === 'ko' && res.t.results) {
  //           promises.push(
  //             TranslationChannelService.createTranslation(paramsId, {
  //               'id-u': 0,
  //               comm: 'KR',
  //               t: res.t.results.ko,
  //               txt: res.txt ? res.txt.results.ko : '',
  //               sht: res.sht ? res.sht.results.ko : '',
  //               'txt-wel': res.txt_wel ? res.txt_wel.results.ko : '',
  //             }),
  //           )
  //         }
  //         if (languages[i] === 'ja' && res.t.results) {
  //           promises.push(
  //             TranslationChannelService.createTranslation(paramsId, {
  //               'id-u': 0,
  //               comm: 'JP',
  //               t: res.t.results.ja,
  //               txt: res.txt ? res.txt.results.ja : '',
  //               sht: res.sht ? res.sht.results.ja : '',
  //               'txt-wel': res.txt_wel ? res.txt_wel.results.ja : '',
  //             }),
  //           )
  //         }
  //       }

  //       $q.all(promises)
  //         .then(function () {
  //           if (route === 'intro') {
  //             CacheService.saveId('channelId', paramsId)
  //             $state.go(route)
  //           } else {
  //             $state.go(route, { parentId: paramsId })
  //           }
  //         })
  //         .catch(function () {
  //           swal('Error in translation, please send message to qp2 administrator!', '', 'error')
  //         })
  //     },
  //   )
  // }

  vm.save = function (isValid) {
    if (!isValid) {
      toastr.warning('Complete all fields!')
      $('html, body').animate({ scrollTop: 0 }, 1000)
      return
    }

    var isHL = true,
      isTXT = true,
      isBG = true

    if (vm.model['color-hl'] !== undefined && vm.model['color-hl'] !== '') {
      isHL = /(^#[0-9a-fA-F]{6}$)/i.test(vm.model['color-hl'])
    }

    if (vm.model['color-txt'] !== undefined && vm.model['color-txt'] !== '') {
      isTXT = /(^#[0-9a-fA-F]{6}$)/i.test(vm.model['color-txt'])
    }

    if (vm.model['color-bg'] !== undefined && vm.model['color-bg'] !== '') {
      isBG = /(^#[0-9a-fA-F]{6}$)/i.test(vm.model['color-bg'])
    }

    if (!isHL) {
      swal('Highlight Color is invalid hexcolor.', '', 'error')
      return
    }

    if (!isTXT) {
      swal('Text Color is invalid hexcolor.', '', 'error')
      return
    }

    if (!isBG) {
      swal('Background Color is invalid hexcolor.', '', 'error')
      return
    }

    if (vm.model['ctr-url'] && vm.validateSpotifyURL(vm.model['ctr-url'])) {
      swal(vm.validateSpotifyURL(vm.model['ctr-url']), '', 'error')
      return
    }

    var listTags = $('#e7').select2('val')
    var modelTags = []
    if (listTags !== undefined) {
      if (vm.model.tags !== undefined) {
        for (var i = 0; i < vm.model.tags.length; i++) {
          for (var j = 0; j < listTags.length; j++) {
            if (parseInt(listTags[j]) === vm.model.tags[i].id) {
              modelTags.push(vm.model.tags[i])
            }
          }
        }
      }

      for (var i = 0; i < vm.tagsList.length; i++) {
        for (var j = 0; j < listTags.length; j++) {
          if (parseInt(listTags[j]) === vm.tagsList[i].id) {
            modelTags.push(vm.tagsList[i])
          }
        }
      }
    }

    vm.model.txt = editor.root.innerHTML
    if (editor.root.innerHTML === '<p><br></p>') {
      vm.model.txt = ''
    }

    vm.model['id-bl'] = parseInt(vm.model['id-bl'])
    vm.model.ar = parseInt(vm.model.ar)
    if (vm.model.ar === 0) {
      swal('Channel Rating Required', '', 'error')
      return
    }

    if (vm.date) {
      if (isDate(vm.date)) {
        var date = parseInt(new Date(new Date(vm.date).setSeconds(0)).getTime() * 1000)
        vm.model['ts-p'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    }

    if (vm.model['cw-url'] == undefined) vm.model['cw-url'] = ''
    if (vm.model['ig-url'] == undefined) vm.model['ig-url'] = ''
    if (vm.model['fb-url'] == undefined) vm.model['fb-url'] = ''
    if (vm.model['yt-url'] == undefined) vm.model['yt-url'] = ''
    if (vm.model['tik-url'] == undefined) vm.model['tik-url'] = ''
    if (vm.model['twt-url'] == undefined) vm.model['twt-url'] = ''
    if (vm.model['s-url'] == undefined) vm.model['s-url'] = ''
    if (vm.model['ctr-url'] == undefined) vm.model['ctr-url'] = ''
    if (vm.model['lkn-url'] == undefined) vm.model['lkn-url'] = ''

    if (edit) {
      ChannelsService.update($stateParams.id, vm.model).then(function (result) {
        CacheService.saveId('channelId', vm.model.id)
        TagsService.addTagChannel(result.results.id, modelTags).then(
          function () {
            var rls
            if (vm.restrictions !== undefined || vm.restrictions !== null) {
              rls = vm.restrictions.toString()
            } else {
              rls = ''
            }
            ChannelsService.saveLocales(result.results.id, rls).then(function () {
              SetsService.getChannelId(result.results.id).then(function (result1) {
                if (result1.results.length === 0) {
                  // makeTranslation(
                  //   vm.model.t,
                  //   vm.model.txt,
                  //   vm.model.sht,
                  //   vm.model['txt-wel'],
                  //   vm.channelTranslations,
                  //   result.results.id,
                  //   'pub.channels.sets',
                  // )
                  $state.go('pub.channels.sets', {
                    parentId: result.results.id,
                  })
                } else {
                  // makeTranslation(
                  //   vm.model.t,
                  //   vm.model.txt,
                  //   vm.model.sht,
                  //   vm.model['txt-wel'],
                  //   vm.channelTranslations,
                  //   result.results.id,
                  //   'pub.channels.sets',
                  // )
                  $state.go('pub.channels.sets', {
                    parentId: result.results.id,
                  })
                }
              })
            })
          },
          function () {
            SetsService.getChannelId(result.results.id).then(function (result1) {
              if (result1.results.length === 0) {
                // makeTranslation(
                //   vm.model.t,
                //   vm.model.txt,
                //   vm.model.sht,
                //   vm.model['txt-wel'],
                //   vm.channelTranslations,
                //   result.results.id,
                //   'pub.channels.sets',
                // )
                $state.go('pub.channels.sets', {
                  parentId: result.results.id,
                })
              } else {
                // makeTranslation(
                //   vm.model.t,
                //   vm.model.txt,
                //   vm.model.sht,
                //   vm.model['txt-wel'],
                //   vm.channelTranslations,
                //   result.results.id,
                //   'pub.channels.sets',
                // )
                $state.go('pub.channels.sets', {
                  parentId: result.results.id,
                })
              }
            })
          },
        )
      })
    } else {
      ChannelsService.save(vm.model).then(function (result) {
        CacheService.saveId('channelId', result.results.id)
        TagsService.addTagChannel(result.results.id, modelTags).then(
          function () {
            var rls
            if (vm.restrictions !== undefined || vm.restrictions !== null) {
              rls = vm.restrictions.toString()
            } else {
              rls = ''
            }
            ChannelsService.saveLocales(result.results.id, rls).then(function () {
              toastr.success('Saved. Now you can add images')
              // makeTranslation(
              //   vm.model.t,
              //   vm.model.txt,
              //   vm.model.sht,
              //   vm.model['txt-wel'],
              //   vm.channelTranslations,
              //   result.results.id,
              //   'pub.channels',
              // )
              $state.go('pub.channels')
              $('html, body').animate({ scrollTop: 0 }, 1000)
            })
          },
          function () {
            // makeTranslation(
            //   vm.model.t,
            //   vm.model.txt,
            //   vm.model.sht,
            //   vm.model['txt-wel'],
            //   vm.channelTranslations,
            //   result.results.id,
            //   'pub.channels',
            // )
            $state.go('pub.channels')

            $('html, body').animate({ scrollTop: 0 }, 1000)
          },
        )
      })
    }
  }

  var watchSweepPdf = $scope.$watch('vm.fileSweepPdf', function (newVal, oldVal) {
    if (newVal === oldVal || newVal === null) {
      vm.loadSweepPdf = false
      return
    }

    vm.loadSweepPdf = true

    UploadService.save('channels', newVal, 'st-pdf', $stateParams.id).then(function (fileName) {
      vm.loadSweepPdf = false
      vm.model['st-pdf'] = fileName
    })
  })

  var watch = $scope.$watch('vm.fileImgT', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadT = false
      return
    }

    if (newVal === null) {
      vm.loadT = false
      return
    }

    vm.loadT = true
    UploadService.save('channels', newVal, 'img-t', $stateParams.id).then(function (fileName) {
      vm.loadT = false
      vm.model['img-t'] = fileName
      vm.pathImgT = fileName
    })
  })

  var watch1 = $scope.$watch('vm.fileImgH', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadH = false
      return
    }

    if (newVal === null) {
      vm.loadH = false
      return
    }

    vm.loadH = true
    UploadService.save('channels', newVal, 'img-h', $stateParams.id).then(function (fileName) {
      vm.loadH = false
      vm.model['img-h'] = fileName
      vm.pathImgH = fileName
    })
  })

  var watch2 = $scope.$watch('vm.fileImgL', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadL = false
      return
    }

    if (newVal === null) {
      vm.loadL = false
      return
    }

    vm.loadL = true
    UploadService.save('channels', newVal, 'img-s-s', $stateParams.id).then(function (fileName) {
      vm.loadL = false
      vm.model['img-s-s'] = fileName
      vm.pathImgL = fileName
    })
  })

  var watch3 = $scope.$watch('vm.cover', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    $('html, body').animate({ scrollTop: 0 }, 'fast')
    UploadService.save('channels', newVal, 'img-c', $stateParams.id).then(function (fileName) {
      swal('Upload complete !')
      var top = $('.preview').height() - 40 - ($('.preview').height() - 40) * 2
      var right = 3
      $('.iphone-screen').css('margin-top', top).css('margin-right', right)
      vm.pathScreen = fileName
    })
  })

  var watch4 = $scope.$watch('vm.fileImgS', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadS = false
      return
    }

    if (newVal === null) {
      vm.loadS = false
      return
    }

    vm.loadS = true
    UploadService.save('channels', newVal, 'img-s', $stateParams.id).then(function (fileName) {
      vm.loadS = false
      vm.model['img-s'] = fileName
      vm.pathImgS = fileName
    })
  })

  var watch5 = $scope.$watch('vm.fileImgW', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadW = false
      return
    }

    if (newVal === null) {
      vm.loadW = false
      return
    }

    vm.loadW = true
    UploadService.save('channels', newVal, 'img-wel', $stateParams.id).then(function (fileName) {
      vm.loadW = false
      vm.model['img-wel'] = fileName
      vm.pathImgW = fileName
    })
  })

  var watch6 = $scope.$watch('vm.fileImgLSM', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadLSM = false
      return
    }

    if (newVal === null) {
      vm.loadLSM = false
      return
    }

    vm.loadLSM = true
    UploadService.save('channels', newVal, 'img-logo-l-sm', $stateParams.id).then(
      function (fileName) {
        vm.loadLSM = false
        vm.model['img-logo-l-sm'] = fileName
        vm.pathImgLSM = fileName
      },
    )
  })

  var watch7 = $scope.$watch('vm.fileImgDSM', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadDSM = false
      return
    }

    if (newVal === null) {
      vm.loadDSM = false
      return
    }

    vm.loadDSM = true
    UploadService.save('channels', newVal, 'img-logo-d-sm', $stateParams.id).then(
      function (fileName) {
        vm.loadDSM = false
        vm.model['img-logo-d-sm'] = fileName
        vm.pathImgDSM = fileName
      },
    )
  })

  var watch8 = $scope.$watch('vm.fileImgLLG', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadLLG = false
      return
    }

    if (newVal === null) {
      vm.loadLLG = false
      return
    }

    vm.loadLLG = true
    UploadService.save('channels', newVal, 'img-logo-l-lg', $stateParams.id).then(
      function (fileName) {
        vm.loadLLG = false
        vm.model['img-logo-l-lg'] = fileName
        vm.pathImgLLG = fileName
      },
    )
  })

  var watch9 = $scope.$watch('vm.fileImgDLG', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadDLG = false
      return
    }

    if (newVal === null) {
      vm.loadDLG = false
      return
    }

    vm.loadDLG = true
    UploadService.save('channels', newVal, 'img-logo-d-lg', $stateParams.id).then(
      function (fileName) {
        vm.loadDLG = false
        vm.model['img-logo-d-lg'] = fileName
        vm.pathImgDLG = fileName
      },
    )
  })

  var watch10 = $scope.$watch('vm.fileImgF', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadDLG = false
      return
    }

    if (newVal === null) {
      vm.loadDLG = false
      return
    }

    vm.loadDLG = true
    UploadService.save('features', newVal, 'img', $stateParams.id).then(function (fileName) {
      vm.loadDLG = false
      vm.model['img-logo-d-lg'] = fileName
      vm.pathImgDLG = fileName
    })
  })

  var watch11 = $scope.$watch('vm.fileImgT11', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadT11 = false
      return
    }

    if (newVal === null) {
      vm.loadT11 = false
      return
    }

    vm.loadT11 = true
    UploadService.save('channels', newVal, 'img-11', $stateParams.id).then(function (fileName) {
      vm.loadT11 = false
      vm.model['img-11'] = fileName
      vm.pathImgT11 = fileName
    })
  })

  var watch12 = $scope.$watch('vm.fileImgT21', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadT21 = false
      return
    }

    if (newVal === null) {
      vm.loadT21 = false
      return
    }

    vm.loadT21 = true
    UploadService.save('channels', newVal, 'img-21', $stateParams.id).then(function (fileName) {
      vm.loadT21 = false
      vm.model['img-21'] = fileName
      vm.pathImgT21 = fileName
    })
  })

  var watch13 = $scope.$watch('vm.fileImgT31', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadT31 = false
      return
    }

    if (newVal === null) {
      vm.loadT31 = false
      return
    }

    vm.loadT31 = true
    UploadService.save('channels', newVal, 'img-31', $stateParams.id).then(function (fileName) {
      vm.loadT31 = false
      vm.model['img-31'] = fileName
      vm.pathImgT31 = fileName
    })
  })

  var watch14 = $scope.$watch('vm.fileImgT22', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadT22 = false
      return
    }

    if (newVal === null) {
      vm.loadT22 = false
      return
    }

    vm.loadT22 = true
    UploadService.save('channels', newVal, 'img-22', $stateParams.id).then(function (fileName) {
      vm.loadT22 = false
      vm.model['img-22'] = fileName
      vm.pathImgT22 = fileName
    })
  })

  var watch15 = $scope.$watch('vm.fileImgLand', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadLand = false
      return
    }

    if (newVal === null) {
      vm.loadLand = false
      return
    }

    vm.loadLand = true
    UploadService.save('channels', newVal, 'img-web-l', $stateParams.id).then(function (fileName) {
      vm.loadLand = false
      vm.model['img-web-l'] = fileName
      vm.pathImgLand = fileName
    })
  })

  var watch18 = $scope.$watch('vm.fileImgPhT', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadPhT = false
      return
    }

    if (newVal === null) {
      vm.loadPhT = false
      return
    }

    vm.loadPhT = true
    UploadService.save('channels', newVal, 'img-ph-t', $stateParams.id).then(function (fileName) {
      vm.loadPhT = false
      vm.model['img-ph-t'] = fileName
      vm.pathImgPhT = fileName
    })
  })

  var watch19 = $scope.$watch('vm.fileImgPhS', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadPhS = false
      return
    }

    if (newVal === null) {
      vm.loadPhS = false
      return
    }

    vm.loadPhS = true
    UploadService.save('channels', newVal, 'img-ph-s', $stateParams.id).then(function (fileName) {
      vm.loadPhS = false
      vm.model['img-ph-s'] = fileName
      vm.pathImgPhS = fileName
    })
  })

  var watch20 = $scope.$watch('vm.fileImgPhCf', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadPhCf = false
      return
    }

    if (newVal === null) {
      vm.loadPhCf = false
      return
    }

    vm.loadPhCf = true
    UploadService.save('channels', newVal, 'img-ph-cf', $stateParams.id).then(function (fileName) {
      vm.loadPhCf = false
      vm.model['img-ph-cf'] = fileName
      vm.pathImgPhCf = fileName
    })
  })

  var watch21 = $scope.$watch('vm.fileImgPhCb', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadPhCb = false
      return
    }

    if (newVal === null) {
      vm.loadPhCb = false
      return
    }

    vm.loadPhCb = true
    UploadService.save('channels', newVal, 'img-ph-cb', $stateParams.id).then(function (fileName) {
      vm.loadPhCb = false
      vm.model['img-ph-cb'] = fileName
      vm.pathImgPhCb = fileName
    })
  })

  vm.newUploadObj = false
  var watch21 = $scope.$watch('vm.filePhObj', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadPhObj = false
      return
    }

    if (newVal === null) {
      vm.loadPhObj = false
      return
    }

    vm.loadPhObj = true
    UploadService.save('channels', newVal, 'obj-ph', $stateParams.id).then(function (fileName) {
      vm.loadPhObj = false
      vm.model['obj-ph'] = fileName
      vm.pathPhObj = fileName
      vm.newUploadObj = true
      vm.glbProgress = 0
    })
  })

  var watch22 = $scope.$watch('vm.fileImgHWeb', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadHWeb = false
      return
    }

    if (newVal === null) {
      vm.loadHWeb = false
      return
    }

    vm.loadHWeb = true
    UploadService.save('channels', newVal, 'img-h-web', $stateParams.id).then(function (fileName) {
      vm.loadHWeb = false
      vm.model['img-h-web'] = fileName
      vm.pathImgHWeb = fileName
    })
  })

  var watch22 = $scope.$watch('vm.fileImgHMob', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadHMob = false
      return
    }

    if (newVal === null) {
      vm.loadHMob = false
      return
    }

    vm.loadHMob = true
    UploadService.save('channels', newVal, 'img-h-mob', $stateParams.id).then(function (fileName) {
      vm.loadHMob = false
      vm.model['img-h-mob'] = fileName
      vm.pathImgHMob = fileName
    })
  })

  // var watch23 = $scope.$watch('vm.fileVideoTrailer', function (newVal, oldVal) {
  //   if (newVal === oldVal) {
  //     vm.loadTrailer = false
  //     return
  //   }

  //   if (newVal === null) {
  //     vm.loadTrailer = false
  //     return
  //   }

  //   vm.loadTrailer = true
  //   UploadService.save('channels', newVal, 'vid-t', $stateParams.id).then(function (fileName) {
  //     vm.loadTrailer = false
  //     vm.model['vid-t'] = fileName
  //     vm.pathVideoTrailer = fileName
  //     vm.videoTrailer = $sce.trustAsResourceUrl(
  //       $rootScope.urlS3 + '/channels/' + vm.pathVideoTrailer,
  //     )
  //   })
  // })

  vm.glbProgress = 0
  $rootScope.$on('uploadProgress', function (event, data) {
    vm.glbProgress = data
    $scope.$apply()
  })

  $scope.$on('$destroy', function () {
    watch()
    watch1()
    watch2()
    watch3()
    watch4()
    watch5()
    watch6()
    watch7()
    watch8()
    watch9()
    watch10()
    watch11()
    watch12()
    watch13()
    watch14()
    watch15()
    watch18()
    watch19()
    watch20()
    watch21()
    watch22()
    watch23()
    watchSweepPdf()
  })

  vm.deleteImage = function (key) {
    switch (key) {
      case 'img-h':
        vm.pathImgH = ''
        vm.loadH = false
        break
      case 'img-h-web':
        vm.pathImgHWeb = ''
        vm.loadHWeb = false
        break

      case 'img-h-mob':
        vm.pathImgHMob = ''
        vm.loadHMob = false
        break
      case 'img-t':
        vm.pathImgT = ''
        vm.loadT = false
        break
      case 'img-s':
        vm.pathImgS = ''
        vm.loadS = false
        break
      case 'img-11':
        vm.pathImgT11 = ''
        vm.loadT11 = false
        break
      case 'img-ph-t':
        vm.pathImgPhT = ''
        vm.loadPhT = false
        break
      case 'img-ph-s':
        vm.pathImgPhS = ''
        vm.loadPhS = false
        break
      case 'img-ph-cf':
        vm.pathImgPhCf = ''
        vm.loadPhCf = false
        break
      case 'img-ph-cb':
        vm.pathImgPhCb = ''
        vm.loadPhCb = false
        break
      // case 'trailer_video':
      //   vm.pathVideoTrailer = ''
      //   vm.videoTrailer = ''
      //   vm.loadTrailer = false
      //   break
    }
    vm.model[key] = ''
  }

  vm.changePub = function (item) {
    SetsService.listRoyalties(item.pubId).then(function (result) {
      item.roys = result.results
    })
  }

  vm.addRoy = function () {
    for (var i = 0; i < vm.roys.length; i++) {
      if (vm.roys[i].royId === 0) {
        swal('You need save a Royalty first', '', 'warning')
        return
      }
    }

    vm.roys.push({
      pubId: 0,
      royId: 0,
    })
  }

  vm.saveRoy = function (item) {
    ChannelsService.addRoy($stateParams.id, item.royId).then(
      function () {
        toastr.success('Saved')
      },
      function (err) {
        if (err.error.message.indexOf('duplicate key') !== -1) {
          swal('Already exist this Royalty.', '', 'error')
          var countDup = 0
          for (var i = 0; i < vm.roys.length; i++) {
            if (vm.roys[i].royId === item.royId) {
              countDup++
            }
          }

          if (countDup === 2) {
            vm.roys.remove(item)
          }
        }
        return
      },
    )
  }

  vm.removeRoy = function (item) {
    if (item.royId === 0) {
      vm.roys.remove(item)
    } else {
      ChannelsService.removeRoy($stateParams.id, item.royId).then(
        function () {
          toastr.success('Deleted')
          vm.roys.remove(item)
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.ytLinks = []
  vm.addYtLink = function () {
    if (vm.ytLinks.length >= 3) {
      swal('You can only add up to 3 YouTube links', '', 'warning')
      return
    }

    vm.ytLinks.push({
      id: 0,
      'vid-id': '',
      desc: '',
    })
  }

  vm.saveYtLink = function (item) {
    var error = vm.validateYoutubeURL(item['vid-id'])
    if (error) {
      swal(error, '', 'error')
      return
    }

    var payload = {
      'vid-id': item['vid-id'],
      desc: item.desc,
    }

    if (item.id === 0) {
      ChannelsService.addYtLink($stateParams.id, payload).then(
        function (result) {
          item.id = result.results.id
          toastr.success('Saved')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      ChannelsService.updateYtLink($stateParams.id, item.id, payload).then(
        function () {
          toastr.success('Updated')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.removeYtLink = function (item) {
    if (item.id === 0) {
      vm.ytLinks.remove(item)
    } else {
      swal(
        {
          title: 'Are you sure?',
          text: 'You want to delete this YouTube link',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            ChannelsService.deleteYtLink($stateParams.id, item.id).then(
              function () {
                toastr.success('Deleted')
                vm.ytLinks.remove(item)
              },
              function (err) {
                swal(err.error.message, '', 'error')
              },
            )
          }
        },
      )
    }
  }

  vm.modal = function () {
    $('#modalTags').modal('show')
  }

  vm.saveTags = function () {
    var split = vm.upTags.split(',')
    var tags = []
    for (var i = 0; i < split.length; i++) {
      tags.push({ name: split[i].trim() })
    }
    for (var x = 0; x < vm.model.tags.length; x++) {
      tags.push({ name: vm.model.tags[x].name })
    }
    TagsService.addTagChannel($stateParams.id, tags).then(function () {
      toastr.success('Saved')
      $('#modalTags').modal('hide')
      $state.reload()
    })
  }

  vm.cancel = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          $state.go('pub.channels')
        }
      },
    )
  }

  vm.uploadRestrictions = function () {
    var reader = new FileReader()
    reader.readAsText(vm.upRestrictions)
    reader.onload = function (event) {
      var csv = event.target.result
      var arr = CsvService.csvToArray(csv)
      arr.shift()
      var newArr = []
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][1]) newArr.push(arr[i][1])
        if (arr[i][2]) newArr.push(arr[i][2])
      }

      var rls
      if (vm.restrictions !== undefined || vm.restrictions !== null) {
        rls = newArr.toString()
      } else {
        rls = ''
      }
      ChannelsService.saveLocales($stateParams.id, rls).then(function () {
        vm.restrictions = rls
        toastr.success('Upload complete!')
      })
    }
  }

  vm.glossary = null
  vm.loadGlossary = false
  vm.uploadGlossary = function () {
    vm.loadGlossary = true
    var reader = new FileReader()
    reader.readAsText(vm.glossary)
    reader.onload = function (event) {
      var csv = event.target.result
      var arr = CsvService.csvToArray(csv)
      var headers = arr[0]

      if (headers.length > 3) {
        swal("Don't support more 3 languages at same time", '', 'error')
        vm.loadGlossary = false
        return
      }

      var enIndex, tcIndex, scIndex
      if (headers[0] === 'en') {
        enIndex = 0
      } else if (headers[0] === 'tc') {
        tcIndex = 0
      } else {
        scIndex = 0
      }
      if (headers[1] === 'en') {
        enIndex = 1
      } else if (headers[1] === 'tc') {
        tcIndex = 1
      } else {
        scIndex = 1
      }
      if (headers[2] === 'en') {
        enIndex = 2
      } else if (headers[2] === 'tc') {
        tcIndex = 2
      } else {
        scIndex = 2
      }

      arr.shift()
      var newArr = []
      for (var i = 0; i < arr.length; i++) {
        newArr.push({
          en: arr[i][enIndex],
          tc: arr[i][tcIndex],
          sc: arr[i][scIndex],
        })
      }

      TranslatorService.uploadGlossary($stateParams.id, newArr).then(
        function (res) {
          vm.glossaryName = res.glossary_id
          toastr.success('Upload complete!')
          vm.loadGlossary = false
        },
        function () {
          toastr.error('Upload error!')
          vm.loadGlossary = false
        },
      )
    }
  }

  vm.isOpenChecklist1 = false
  vm.openCalendarChecklist1 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist1 = true
  }

  vm.isOpenChecklist2 = false
  vm.openCalendarChecklist2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist2 = true
  }

  vm.isOpenChecklist3 = false
  vm.openCalendarChecklist3 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist3 = true
  }

  vm.isOpenChecklist4 = false
  vm.openCalendarChecklist4 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenChecklist4 = true
  }

  vm.isOpenDate = false
  vm.openCalendarDate = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpenDate = true
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.valRankMin = ''
  vm.valRankMax = ''
  vm.createChecklist = function () {
    if (!vm.checklistOption) {
      swal('You must select a option', '', 'warninng')
      return
    }

    if (vm.checklistOption === 'clean_slate') {
      var startsAt
      var endsAt
      if (
        vm.dataChecklist2 !== undefined &&
        vm.dataChecklist2 !== '' &&
        vm.dataChecklist2 !== null
      ) {
        if (isDate(vm.dataChecklist2)) {
          startsAt = new Date(vm.dataChecklist2).toISOString()
        } else {
          startsAt = new Date().toISOString()
        }
      } else {
        startsAt = new Date().toISOString()
      }
      if (
        vm.dataChecklist3 !== undefined &&
        vm.dataChecklist3 !== '' &&
        vm.dataChecklist3 !== null
      ) {
        if (isDate(vm.dataChecklist3)) {
          endsAt = new Date(vm.dataChecklist3).toISOString()
        } else {
          endsAt = ''
        }
      } else {
        endsAt = ''
      }

      SetsService.createChecklistCleanSlate(
        vm.model.id,
        'channels',
        startsAt,
        endsAt,
        vm.valRankMin,
        vm.valRankMax,
        '',
        'simple',
        vm.albumType,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist2 = null
          vm.dataChecklist3 = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>Clean slate checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.seg[0].id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'rank') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      if (!vm.rankMin) {
        vm.rankMin = 1
      }

      SetsService.createChecklistRank(
        vm.model.id,
        'channels',
        expiredAt,
        'Top',
        vm.rankMin,
        vm.rankMax,
        bundleID,
        '',
        'simple',
        vm.albumType,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist4 = null
          vm.rankMax = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>Rank checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'first') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      if (!vm.rankMin) {
        vm.rankMin = 1
      }

      SetsService.createChecklistRank(
        vm.setId,
        'channels',
        expiredAt,
        'First',
        vm.rankMin,
        vm.rankMax,
        bundleID,
      ).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist4 = null
          vm.rankMin = null
          vm.rankMax = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += '<h3>First checklist created</h3><br />'
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html +=
              '<li>Reward url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0]['id-rew'] +
              '" target="_blank">' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0].id +
              '</a></li>'
            html +=
              '<li>Set url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '" target="_blank">' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    } else if (vm.checklistOption === 'hold') {
      var expiredAt
      var bundleID = parseInt($('#e8').select2('val'))

      if (
        vm.dataChecklist4 !== undefined &&
        vm.dataChecklist4 !== '' &&
        vm.dataChecklist4 !== null
      ) {
        if (isDate(vm.dataChecklist4)) {
          expiredAt = new Date(vm.dataChecklist4).toISOString()
        } else {
          expiredAt = ''
        }
      } else {
        expiredAt = ''
      }

      SetsService.createChecklistHold(vm.setId, 'channels', expiredAt, bundleID).then(
        function (res) {
          $('#e8').select2('data', null)
          vm.dataChecklist4 = null

          $timeout(function () {
            var url = window.location.origin
            var html = ''
            html += ''
            html += "<h3>Hold 'Em checklist created</h3><br />"
            html +=
              '<ul style="text-align: left;font-size: 15px;word-break: break-all;line-height: 1.8;">'
            html +=
              '<li>Checklist url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '" target="_blank">' +
              url +
              '/admin/checklist/' +
              res.results.checklist.id +
              '</a></li>'
            html +=
              '<li>User Segmentation url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '" target="_blank">' +
              url +
              '/admin/user_segmentation/' +
              res.results.checklist.seg[0].id +
              '</a></li>'
            html +=
              '<li>Reward url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0]['id-rew'] +
              '" target="_blank">' +
              url +
              '/admin/rewards/' +
              res.results.checklist.rew[0].id +
              '</a></li>'
            html +=
              '<li>Set url: <a style="margin-top: 5px; color:#337ab7; cursor:pointer;" href="' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '" target="_blank">' +
              url +
              '/publisher/channels/' +
              res.results.set['id-ch'] +
              '/sets/edit/' +
              res.results.set.id +
              '</a></li>'
            html += '</ul>'
            swal({
              title: html,
              text: '',
              html: true,
            })
          }, 500)
        },
        function (err) {
          $timeout(function () {
            swal(err.error ? err.error.message : 'Params is required', '', 'error')
          }, 250)
        },
      )
    }
  }

  vm.filterBundleID = false
  vm.clickBundleId = function () {
    if (vm.filterBundleID) {
      vm.filterBundleID = false
      $rootScope.bundleType = ''
    } else {
      vm.filterBundleID = true
      $rootScope.bundleType = 'bundle'
    }
  }
}
